import { useRef, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { keyframes } from '@emotion/react';
import { tokens } from "../../../theme";
import HeaderDetail from '../../../components/header/HeaderDetail';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import GaugeChart from "../../../components/chart/GaugeChart"
import db from "../../../firebase-config";
import useCheckToken from '../../../hooks/useCheckToken';
import useExchangeToken from "../../../hooks/useExchangeToken";
import PopupGiveawayRollout from '../../../components/model/PopupGiveawayRollout';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#bcd6d0',
    padding: theme.spacing(0),
    textAlign: 'center',
    //border: '0.8px dashed #2e9281',
    borderRadius: 30,
    height: '100%'

}));

const ItemGiveaway = styled(Paper)(({ theme }) => ({
    backgroundColor: '#000000',
    padding: theme.spacing(0),
    textAlign: 'center',
    border: "3px dashed #4a4a49",
    borderRadius: 30,
    //height: '102%'

}));

const ItemActual = styled(Paper)(({ theme }) => ({
    backgroundColor: '#4a4a49',
    padding: theme.spacing(0),
    textAlign: 'center',
    //border: "3px dashed #4a4a49",
    borderRadius: 20,
    //height: '102%'

}));


/* ------------------------------------------------------------------
 * AI ALIVE glow (L5_PG_ALIVE_GA)
 * โทนสี teal เดียวกับสเกล giveaway ฝั่งดี (#2c8c7c → #96ded2)
 * ไม่ใช้เหลือง/แดง เพื่อไม่ให้ไปชนกับความหมาย "เตือน"
 * ------------------------------------------------------------------ */
const aiGlow = keyframes`
  0%, 100% { text-shadow: 0 0 2px currentColor; }
  50%      { text-shadow: 0 0 10px yellow; }
`;

const reducedMotion = '@media (prefers-reduced-motion: reduce)';

// ชื่อ Line: สีตัวอักษรเดิม ขอบแสงสลับเหลืองทุก 1 วินาที
const GlowLine = ({ text }) => (
    <Box component="span" sx={{
        color: 'inherit',
        animation: `${aiGlow} 1s steps(2, start) infinite`,
        [reducedMotion]: { animation: 'none', textShadow: '0 0 10px yellow' },
    }}>
        {text}
    </Box>
);

const toBool = (v) => v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true';


const GiveawayRolloutPage1 = () => {
    const { bu, plant, factory, line } = useParams();
    const exchangeToken = useExchangeToken();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isTokenExchanged, setIsTokenExchanged] = useState(false);
    const [error, setError] = useState(null);
    const [giveaway_rollout, setgiveaway_rollout] = useState([]);
    const [giveaway_rollout_store, setgiveaway_rollout_store] = useState([]);
    const [giveaway_taglist, setgiveaway_taglist] = useState([]);

    // prefix ของ tag เดิม (สร้างครั้งเดียว ใช้ร่วมกันทุก tag)
    const tagProvider = plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further';
    const tagFactory = factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory;
    const tagCountry = plant === 'B425' ? 'Vietnam' : 'Thailand';
    const tagPrefix = `${tagProvider}.${plant}.${tagFactory}.${tagCountry}.Dashboard.GiveAway.${line}`;

    useCheckToken()

    useEffect(() => {
        const fetchInitialTokenAndData = async () => {
            try {
                const token = await exchangeToken();
                if (token) {
                    setIsTokenExchanged(true);
                }
            } catch (err) {
                console.error("Error exchanging token:", err);
                setError("Failed to exchange token");
            }
        };
        fetchInitialTokenAndData();
    }, [exchangeToken]);

    const isNA = (v) => v === 'NA' || v === 'na' || v === 'Na';
    const isDash = (v) => v === '-' || v === '';
    const isInvalid = (v) => v === undefined || v === null || isNA(v) || isDash(v);

    const formatNum = (val, maximumFractionDigits = 2, fallback = '-') => {
        if (isInvalid(val)) {
            if (isNA(val)) return 'NA';
            return fallback;
        }
        const n = Number(val);
        if (Number.isNaN(n)) return fallback;
        if (n <= 0) return '0';
        return n.toLocaleString(undefined, { maximumFractionDigits });
    };

    const formatInt = (val, fallback = '0') => {
        if (isInvalid(val)) {
            if (isNA(val)) return 'NA';
            return fallback;
        }
        const n = Number(val);
        if (Number.isNaN(n)) return fallback;
        if (n <= 0) return '0';
        return Math.round(n).toLocaleString();
    };


    useEffect(() => {
        const docId = `${plant === 'B425' ? 'Vietnam' : 'Thailand'}${plant}${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}${line}Giveaway_V2`;
        const docRef = db.collection('prod_mes_ignition_giveaway_v2').doc(docId);
        const subscribe = docRef.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                const data = { ...docSnapshot.data(), id: docSnapshot.id };
                setgiveaway_rollout(data);
                sessionStorage.setItem("GiveawayRollout", JSON.stringify(data));

            } else {
                console.log('No such document!');
                setgiveaway_rollout([]);
            }
        });

        const subscriberGiveawayTaglist = db
            .collection("prod_mes_ignition_giveaway_v2_tag_list")
            .where("TAG_NAME", "in", [
                `${tagPrefix}.MTH_Status`,
                `${tagPrefix}.CW_Status`,
                `${tagPrefix}.Counter_Status`,
                `${tagPrefix}.L5_PG_ALIVE_GA`,
            ])
            .onSnapshot((querySnapshot) => {
                const giveawayData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));

                setgiveaway_taglist(giveawayData);
            });

        return () => {
            subscribe();
            subscriberGiveawayTaglist();
        }
    }, []);

    useEffect(() => {
        const stored = sessionStorage.getItem("GiveawayRollout");
        if (stored) setgiveaway_rollout_store(JSON.parse(stored));
    }, []);

    const findMachine = (key) => (giveaway_taglist || []).find((a) => (a?.TAG_NAME || "").includes(key)) || null;

    const multiheadStatus = findMachine(`${tagPrefix}.MTH_Status`);
    const checkWeightStatus = findMachine(`${tagPrefix}.CW_Status`);
    const AICameraStatus = findMachine(`${tagPrefix}.Counter_Status`);
    const aiAliveTag = findMachine(`${tagPrefix}.L5_PG_ALIVE_GA`);

    // ไม่มี tag หรือ VALUE = false/0 → ไม่แสดงอะไร
    const isAIAlive = !!aiAliveTag && toBool(aiAliveTag.VALUE);

    const getColorGiveaway = () => {
        const actual = giveaway_rollout?.WARNING === 'ไม่ตรงแผนการผลิต' || giveaway_rollout?.AVG_GIVEAWAY === '-'
            ? 0
            : Number(giveaway_rollout?.AVG_GIVEAWAY);

        const scale = giveaway_rollout?.WARNING === 'ไม่ตรงแผนการผลิต' || giveaway_rollout?.BEST_PRACTICE === 'NA'
            ? 0
            : Number(giveaway_rollout?.BEST_PRACTICE) * 2;

        const colors = [
            '#2c8c7c', // 0 - 1
            '#37af9b', // 1 - 2
            '#56cab7', // 2 - 3
            '#96ded2', // 3 - 4
            '#f5c842', // 4 - 5
            '#fcad00', // 5 - 6
            '#ec7728', // 6 - 7
            '#e20000', // 7+
        ];

        if (scale === 0) return colors[0]; // fallback default color

        const range = scale / 8;
        const index = Math.min(Math.floor(actual / range), 7);

        return colors[index];
    };

    const getValidValue = (value) => {
        return value === undefined || value === null || value === '-' || value === 'NA' ? 0 : Number(value);
    }

    const sourceOrStore = (key) => {
        const src = giveaway_rollout?.WARNING === undefined ? giveaway_rollout_store : giveaway_rollout;
        return src ? src[key] : undefined;
    };


    return (
        <>
            {giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' || multiheadStatus?.VALUE == false || checkWeightStatus?.VALUE == false || AICameraStatus?.VALUE == true ? <PopupGiveawayRollout /> :
                <Helmet>
                    <title>Giveaway Rollout Page1 | MES</title>
                </Helmet>
            }
            <Box sx={{ fontFamily: '"CPF_Imm_Sook", "CPF Imm Sook", "Sarabun", sans-serif' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ position: 'relative' }}>
                        <HeaderDetail
                            line={isAIAlive ? <GlowLine text={line} /> : line}
                            sku={giveaway_rollout?.WARNING == undefined ? '-' : giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' ? 'ไม่ตรงแผนผลิต' : giveaway_rollout?.SKU}
                            icon={giveaway_rollout?.SHIFT == undefined ? <LightModeOutlinedIcon style={{ height: '55px' }} /> : giveaway_rollout?.SHIFT == 'D' ? <LightModeOutlinedIcon style={{ height: '55px' }} /> : <DarkModeOutlinedIcon style={{ height: '55px' }} />}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} style={{ backgroundColor: colors.neutral['black'], paddingTop: 10, paddingRight: 10, paddingLeft: 10, position: "relative", left: '-1.5vw' }}>
                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                        <Grid item xs={5} style={{ paddingRight: 10 }}>
                            <Item>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }}>
                                    <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                        FG (kg)
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={5.9} >
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                                    Target
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('TARGET_WEIGHT_KG');
                                                        return isInvalid(v) ? '-' : formatInt(v);
                                                    })()}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={0.2} style={{ borderLeft: "2px dashed #000000", height: '12vh', position: "relative", top: '0.5vw' }} >

                                        </Grid>

                                        <Grid item xs={5.9}>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                                    Actual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['green'], fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('ACTUAL_KG');
                                                        return isInvalid(v) ? '-' : formatInt(v);
                                                    })()}
                                                </Typography>
                                            </Grid>
                                            {/* <Box style={{height: '27px'}} >
                                               
                                        </Box> */}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                        <Grid item xs={7}>
                            <Item>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }}>
                                    <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                        FG (bag)
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={3.9} >
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                                    Target
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('TARGET_PACK');
                                                        return isInvalid(v) ? '-' : formatInt(v);
                                                    })()}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={0.1} style={{ borderLeft: "2px dashed #000000", height: '12vh', position: "relative", top: '0.5vw' }} >

                                        </Grid>

                                        <Grid item xs={3.9}>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['black'], fontSize: 42, fontWeight: 'bold' }} >
                                                    Actual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['green'], fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('ACTUAL_PACK');
                                                        return isInvalid(v) ? '-' : formatInt(v);
                                                    })()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                    <Typography style={{ color: "#636363", fontSize: 28, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                        Diff:
                                                    </Typography>
                                                    <Typography style={{ color: "#636363", fontSize: 32, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                        {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                            const v = sourceOrStore('DIFF_PACK');
                                                            return isInvalid(v) ? '-' : formatInt(v);
                                                        })()}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={0.1} style={{ borderLeft: "2px dashed #000000", height: '12vh', position: "relative", top: '0.5vw' }} >

                                        </Grid>

                                        <Grid item xs={3.9}>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: '#8c0e0e', fontSize: 42, fontWeight: 'bold' }} >
                                                    Detected
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: '#8c0e0e', fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('REJECT');
                                                        return isInvalid(v) ? '-' : formatInt(v);
                                                    })()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} style={{ backgroundColor: colors.neutral['black'], paddingTop: 10, paddingRight: 10, paddingLeft: 10, position: "relative", left: '-1.5vw' }}>
                    <ItemGiveaway>
                        <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                            <Grid item xs={3.9}>
                                <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold' }} >
                                            Pack Size
                                        </Typography>
                                        <Typography style={{ color: colors.neutral['white'], fontSize: 26, fontWeight: 'bold', paddingTop: 10 }} >
                                            &nbsp;(g/bag)
                                        </Typography>
                                    </Box>

                                    <Typography style={{ color: colors.neutral['green'], fontSize: 42, fontWeight: 'bold' }} >
                                        Avg. Actual
                                    </Typography>
                                    <Typography style={{ color: colors.neutral['green'], fontSize: 60, fontWeight: 'bold', lineHeight: "4vh" }} >
                                        {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                            const v = sourceOrStore('AVG_ACTUAL_g');
                                            return isInvalid(v) ? '-' : `${formatNum(v, 2, '0')}`;
                                        })()}
                                    </Typography>

                                    <Typography style={{ color: colors.neutral['grey'], fontSize: 42, fontWeight: 'bold', lineHeight: "20vh" }} >
                                        Std.{giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                            const v = sourceOrStore('STD_PACK');
                                            return isInvalid(v) ? '-' : formatInt(v);
                                        })()}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid item xs={0.2} style={{ borderLeft: "2px dashed #4A4A49", height: '30vh', position: "relative", top: '0.5vw' }} >

                            </Grid>

                            <Grid item xs={7.9}>
                                <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 48, fontWeight: 'bold' }} >
                                        Giveaway
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={3} >
                                            <Grid item xs={12} md={12} lg={12} xl={12} style={{ paddingTop: 50 }} >
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 35 }} >
                                                    Best Practice
                                                </Typography>
                                                <Typography style={{ color: colors.neutral['grey'], fontSize: 48, fontWeight: 'bold', lineHeight: "4vh" }} >
                                                    {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                        const v = sourceOrStore('BEST_PRACTICE');
                                                        if (isNA(v)) return 'NA';
                                                        return isInvalid(v) ? '-' : `${formatNum(v, 2, '-')}`;
                                                    })()}%
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} >
                                            <Grid item xs={12} md={12} lg={12} xl={12} style={{ paddingTop: 60 }} >
                                                {(() => {
                                                    const liveVal = giveaway_rollout?.BEST_PRACTICE;
                                                    const useVal = liveVal === undefined ? 0 : liveVal;

                                                    const avg = giveaway_rollout?.AVG_GIVEAWAY;
                                                    const useAVG = avg === undefined ? 0 : avg
                                                    return useVal !== undefined ? (
                                                        <GaugeChart
                                                            value={getValidValue(useAVG)}
                                                            max_chart={getValidValue(useVal)}
                                                            width={450}
                                                            height={100}
                                                        />
                                                    ) : null;
                                                })()}
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={3} >
                                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold' }} >
                                                    Actual
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12} xl={12} style={{ paddingRight: 20, paddingLeft: 20 }} >
                                                <ItemActual>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: giveaway_rollout?.AVG_GIVEAWAY == undefined ? "#f5c842" : getColorGiveaway(), fontSize: 48, fontWeight: 'bold' }} >
                                                            {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                                const v = sourceOrStore('AVG_GIVEAWAY');
                                                                if (isNA(v)) return 'NA';
                                                                return isInvalid(v) ? '-' : `${formatNum(v, 2, '0')}`;
                                                            })()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 26, fontWeight: 'bold', paddingTop: 10 }} >
                                                            &nbsp;%
                                                        </Typography>
                                                    </Box>
                                                </ItemActual>
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12} xl={12} style={{ paddingTop: 10, paddingRight: 20, paddingLeft: 20 }}>
                                                <ItemActual>
                                                    <Typography style={{ color: giveaway_rollout?.AVG_GIVEAWAY == undefined ? "#f5c842" : getColorGiveaway(), fontSize: 48, fontWeight: 'bold' }} >
                                                        {giveaway_rollout?.WARNING === 'ไม่ตรงแผนผลิต' ? '-' : (() => {
                                                            const v = sourceOrStore('LOSS_PACK');
                                                            if (isNA(v)) return 'NA';
                                                            return isInvalid(v) ? '-' : `${formatInt(v, '0')}`;
                                                        })()}
                                                    </Typography>
                                                    <Typography style={{ color: colors.neutral['white'], fontSize: 26, fontWeight: 'bold', lineHeight: "1vh", position: "relative", top: "-0.5vw" }} textAlign="right" >
                                                        bag &nbsp;&nbsp;
                                                    </Typography>
                                                </ItemActual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ItemGiveaway>
                </Grid>
            </Box>
        </>
    )
}

export default GiveawayRolloutPage1
